<template>
  <div v-if="!contextResourceMatch">
    <v-alert color="warning lighten-3" dismissible border="top">
      {{ $t('resource_belongs_to_another_customer', {resource_type: typeDisplayName}) }} {{ $t('switch_to_account') }}:
      <ul>
        <li v-for="customer in resourceCustomers" :key="customer.id" class="mx-1">
          <a href="#" @click="switchContext(customer)">
            <v-icon size="20" color="primary">mdi-office-building</v-icon>
            <span class="mx-1">{{ customer.name }}</span>
          </a>
        </li>
      </ul>
    </v-alert>
  </div>
</template>

<script>

import { map, indexOf, isArray } from 'lodash'
import CurrentUserMixin from '@/components/mixins/CurrentUserMixin'

export default {
  name: 'CustomerContextPrompt',
  mixins: [CurrentUserMixin],
  props: {
    resource: {
      type: Object,
      required: true
    }
  },
  computed: {
    /**
     * The resource name to display, depending on what resource it is
     * @returns {string}
     */
    typeDisplayName () {
      return this.$tc(this.resource.getType())
    },

    /**
     * @return Array|undefined
     */
    resourceCustomers () {
      if (this.resource) {
        const customerIds = this.resource.getCustomerIds()
        if (isArray(customerIds) && customerIds.length > 0) {
          return this.customers.filter(customer => indexOf(customerIds, customer.id) !== -1)
        }
      }
      return undefined
    },

    /**
     * Returns a flag indicating if the current customer context is not found within the resource's customers.
     * @returns {boolean}
     */
    contextResourceMatch () {
      return !isArray(this.resourceCustomers) || indexOf(map(this.resourceCustomers, x => x.id), this.customerContext.id) !== -1
    }
  },
  methods: {
    /**
     * Switch the customer context.
     * @param {CustomerRecord} customer
     */
    switchContext (customer) {
      this.$store.dispatch('userModule/changeCustomerContext', customer.id)
      this.$emit('change-context', customer)
    }
  }
}
</script>

<style scoped>
  ul {
    display: inline;
    padding: 0
  }
  li {
    display: inline;
  }
  li::after {
    content: ", "
  }
  li:last-child::after {
    content: "";
  }
</style>
